<template>
    <div class="article_detail">
        <router-link class="back" :to="{name: backLink}">Zurück</router-link>
        <img class="article_detail__image" v-if="image" :src="image">
        <h1 class="article_detail__title">{{ article.title }}</h1>
        <div class="article_detail__content" v-html="content"></div>
    </div>
</template>

<script type="text/babel">
function nl2br(str) {
  if (typeof str === 'undefined' || str === null) {
    return '';
  }
  return str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
}

module.exports = {
  data() {
    return {};
  },
  computed: {
    article() {
      return this.$store.getters.getArticles
        // eslint-disable-next-line no-bitwise
        .find((article) => this.$route.params.id >>> 0 === article.id);
    },
    image() {
      return this.$helpers.getThumbnail(this.article.image);
    },
    content() {
      if (this.article.description) {
        return nl2br(this.article.description);
      }
      return nl2br(this.article.content);
    },
    backLink() {
      return this.$route.name.split('.')[0];
    },
  },
};
</script>

<style lang="scss">
    .article_detail {
        padding: 1em;
        overflow: auto;
        &__title {
            font-size: 2.25em;
            margin: .25em 0 .5em 0;
            font-weight: 300;
        }
        &__image {
            float: right;
            margin: 0 0 1em 1em;
        }
        .back {
            /*border: solid 2px;*/
            border-radius: 0 0 12px 0;
            text-decoration: none;
            padding: .75em;
            display: table;
            margin: -1em;
            margin-bottom: 1em;
            /*margin: auto;*/
            font-weight: 500;
            text-align: center;
            background: linear-gradient(to right, var(--gradient-color-1), var(--gradient-color-2));
            color: #fff;
        }
    }
</style>
